import { jsx as n, jsxs as l, Fragment as p } from "react/jsx-runtime";
import { useMemo as h } from "react";
import e from "./style.module.less.js";
import L from "./social-fb.svg.js";
import A from "./social-instagram.svg.js";
import T from "./social-tik-tok.svg.js";
import q from "./social-youtube.svg.js";
import _ from "./social-ln.svg.js";
import E from "./logo-white.webp.js";
import { CountryLanguageSelector as F } from "../country-language-selector/index.js";
import { DEFAULT_LANGUAGE_CODE as R, canLanguageUseAtticus as D, areasOfLawData as v, withDirectoryCountries as $, directoryBaseData as I } from "../../../constants.js";
import { convertToKebabCase as b } from "../../../utils/case-conversion.js";
import { getRoute as N, RouteType as k } from "../../../utils/get-route.js";
import x from "../menu/message-animated.svg.js";
import C from "../menu/spark-animated-midnight.svg.js";
import { useFeatureFlags as M } from "../../../context/config-context.js";
const W = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/asklawconnect",
    Icon: L
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/asklawconnect/",
    Icon: A
  },
  {
    name: "TikTok",
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: T
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: _
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@asklawconnect",
    Icon: q
  }
], Y = () => /* @__PURE__ */ n("div", { className: e.socialContainer, children: W.map((c) => /* @__PURE__ */ n(
  "a",
  {
    href: c.link,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": c.name,
    className: e.socialIconContainer,
    children: /* @__PURE__ */ n(c.Icon, { width: 32, height: 32, className: e.socialIcon })
  },
  c.name
)) }), oe = (c) => {
  const {
    className: a = "",
    onLanguageChange: m,
    isAuthenticated: o,
    openAuthModal: d,
    language: s = R,
    getTranslation: i,
    isLawyerSupported: f,
    onRequestLawyer: g
  } = c, y = h(() => D(s) ? s : void 0, [s]), w = h(
    () => i("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, s ? `/${s}/terms` : "/terms").replace(
      /PRIVACY_LINK/g,
      s ? `/${s}/privacy` : "/privacy"
    ),
    [i, s]
  ), t = h(() => s ? v[s] : null, [s]), u = /* @__PURE__ */ n(
    F,
    {
      onLanguageChange: m,
      language: s ?? ""
    }
  ), r = () => /* @__PURE__ */ n(
    "a",
    {
      href: "/account",
      className: `${e.menuItem}`,
      onClick: (S) => {
        o || (S.preventDefault(), d == null || d());
      },
      children: i("pages.account")
    }
  );
  return /* @__PURE__ */ n("footer", { className: `${e.footer} ${a}`, children: /* @__PURE__ */ l("div", { className: e.widthWrapper, children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: `${e.logoContainer} ${t != null && t.length ? e.large : ""}`,
        children: [
          /* @__PURE__ */ n("a", { href: s ? `/${s}` : "/", className: e.logo, children: /* @__PURE__ */ n(
            "img",
            {
              src: E,
              width: 202,
              height: 28,
              alt: "LawConnect Logo",
              loading: "lazy",
              className: e.logoImage
            }
          ) }),
          /* @__PURE__ */ n("div", { className: e.headerLanguageSelector, children: u })
        ]
      }
    ),
    t != null && t.length ? /* @__PURE__ */ n("div", { className: `${e.gridContainer} ${e.large}`, children: /* @__PURE__ */ n(
      B,
      {
        language: s,
        accountComponent: /* @__PURE__ */ n(r, {}),
        isLawyerSupported: f,
        onRequestLawyer: y ? g : void 0
      }
    ) }) : /* @__PURE__ */ n("div", { className: e.gridContainer, children: /* @__PURE__ */ n(
      H,
      {
        language: s,
        accountComponent: /* @__PURE__ */ n(r, {}),
        getTranslation: i
      }
    ) }),
    /* @__PURE__ */ l("div", { className: e.bottomBarContainer, children: [
      /* @__PURE__ */ l("div", { className: e.bottomSocialContainer, children: [
        /* @__PURE__ */ n(Y, {}),
        /* @__PURE__ */ n("div", { className: e.languageSelectorContainer, children: u })
      ] }),
      /* @__PURE__ */ l("div", { className: e.copyright, children: [
        /* @__PURE__ */ n("div", { children: i("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ l("div", { className: e.copyrightBottom, children: [
          /* @__PURE__ */ l("div", { children: [
            i("auth.copyright-description"),
            " "
          ] }),
          t != null && t.length ? /* @__PURE__ */ n("div", { dangerouslySetInnerHTML: { __html: w } }) : null
        ] })
      ] })
    ] })
  ] }) });
}, B = (c) => {
  const { language: a, accountComponent: m, isLawyerSupported: o, onRequestLawyer: d } = c, { diyWill: s } = M(), i = h(() => {
    const t = v[a];
    return $.includes(a) ? [
      ...t,
      {
        title: I.footerTitle ?? "",
        description: I.description,
        image: I.image,
        link: "library"
      }
    ] : t;
  }, [a]), f = h(() => $.includes(a), [a]), g = o ? 5 : 4, y = h(() => {
    const t = g * 2, u = i.slice(0, t);
    return [u.slice(0, g), u.slice(g)];
  }, [i, g]), w = h(() => [
    {
      header: "Browse",
      items: [
        {
          key: "ask",
          label: "Ask a question",
          href: N(k.NEW_CHAT),
          icon: /* @__PURE__ */ n(C, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.askQuestion}`
        },
        {
          key: "request",
          label: "Request a lawyer",
          href: d ? void 0 : N(k.LAWYER_REQUEST_CHAT),
          icon: /* @__PURE__ */ n(x, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.requestLawyer}`,
          show: !!o,
          onClick: d
        },
        {
          key: "library",
          label: "Areas of law",
          href: `/${a}/library`,
          className: e.menuItem
        },
        {
          key: "about",
          label: "About",
          href: a ? `/${a}/about` : "/about",
          className: e.menuItem
        },
        {
          key: "for-lawyers",
          label: "For lawyers",
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: e.menuItem
        },
        {
          key: "account",
          node: m,
          show: !o
        }
      ]
    },
    {
      header: "",
      items: [
        {
          key: "make-will",
          label: "Make a will",
          href: N(k.WILL_INFO),
          className: e.menuItem,
          show: a === "en-us" && s === !0
        },
        {
          key: "insights",
          label: "Insights",
          href: a ? `/${a}/insights` : "/insights",
          className: e.menuItem
        },
        {
          key: "faqs",
          label: "FAQs",
          href: a ? `/${a}/faqs` : "/faqs",
          className: e.menuItem
        },
        {
          key: "directory",
          label: "Case study directory",
          href: a ? `/${a}/directory` : "/directory",
          className: e.menuItem,
          show: f && !!o
        },
        {
          key: "ai-technology",
          label: "Our AI technology",
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: e.menuItem,
          show: !o && !(a === "en-us" && s === !0)
        },
        {
          key: "company",
          label: "Company",
          href: a ? `/${a}/about/company` : "/about/company",
          className: e.menuItem,
          show: !o
        },
        {
          key: "contact",
          label: "Contact us",
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: e.menuItem
        },
        {
          key: "account",
          node: m,
          show: !!o
        }
      ]
    },
    {
      header: "Areas of law",
      items: y[0].map((t) => ({
        key: `area-1-${t.title}`,
        label: t.footerTitle ?? t.title,
        href: `/${a}/${t.link ?? b(t.title)}`,
        className: e.menuItem
      }))
    },
    {
      header: "",
      items: y[1].map((t) => ({
        key: `area-2-${t.title}`,
        label: t.footerTitle ?? t.title,
        href: `/${a}/${t.link ?? b(t.title)}`,
        className: e.menuItem
      }))
    }
  ], [
    a,
    o,
    f,
    y,
    m,
    s
  ]);
  return /* @__PURE__ */ n(p, { children: w.map((t, u) => /* @__PURE__ */ l("div", { className: e.column, children: [
    /* @__PURE__ */ n("div", { className: e.headerLabel, children: t.header ?? "" }),
    t.items.filter((r) => r.show !== !1).map(
      (r) => r.node ? /* @__PURE__ */ n(p, { children: r.node }) : /* @__PURE__ */ n(
        "a",
        {
          href: r.href,
          className: r.className ?? e.menuItem,
          onClick: r.onClick,
          children: r.icon ? /* @__PURE__ */ l(p, { children: [
            /* @__PURE__ */ n("span", { className: e.menuItemText, children: r.label }),
            r.icon
          ] }) : /* @__PURE__ */ n(p, { children: r.label })
        },
        r.key
      )
    )
  ] }, u)) });
}, H = (c) => {
  const { language: a, accountComponent: m, getTranslation: o } = c;
  return /* @__PURE__ */ l(p, { children: [
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ l(
        "a",
        {
          href: N(k.NEW_CHAT),
          className: `${e.menuItem} ${e.askQuestion}`,
          children: [
            o("pages.ask-a-question"),
            /* @__PURE__ */ n(C, { className: e.menuIcon })
          ]
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/about` : "/about",
          className: `${e.menuItem}`,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: `${e.menuItem}`,
          children: o("register.for-lawyers")
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      a.includes("en") ? /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/insights` : "/insights",
          className: `${e.menuItem}`,
          children: o("pages.insights")
        }
      ) : null,
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/faqs` : "/faqs",
          className: `${e.menuItem}`,
          children: o("pages.faqs")
        }
      ),
      a.includes("en") ? null : /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: `${e.menuItem}`,
          children: o("pages.ai-technology")
        }
      ),
      m
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: `${e.menuItem}`,
          children: o("pages.contact-us")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/terms` : "/terms",
          className: `${e.menuItem}`,
          children: o("pages.terms")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/privacy` : "/privacy",
          className: `${e.menuItem}`,
          children: o("pages.privacy-policy")
        }
      )
    ] })
  ] });
};
export {
  oe as FooterComponent,
  W as SOCIAL_MEDIA_LINKS
};
